import { render, staticRenderFns } from "./overallPortrait.vue?vue&type=template&id=effc68c8&scoped=true"
import script from "./overallPortrait.vue?vue&type=script&lang=js"
export * from "./overallPortrait.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=effc68c8&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/table.scss?vue&type=style&index=1&id=effc68c8&prod&lang=scss&scoped=true&external"
import style2 from "./overallPortrait.vue?vue&type=style&index=2&id=effc68c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effc68c8",
  null
  
)

export default component.exports